import React  from 'react';
import { detect } from 'detect-browser' ;
import Validator from "./Validator/Validator"; 
import { Input , Select  } from "../Components/UI/UI" 

import Http from "../Axios/Axios"

export const validateFields = ( fields ) => {
	let errors = [];
	var v = new Validator();
	for ( let i in fields ) {
		const currentField = fields[i]; 
		const  validationType = currentField.validationType;
		let res = null
		if ( validationType === "simple" ) {
			res = v.simpleValidation({
				val : currentField.val ,
				err_1 : currentField.err_1
			});
		} else if ( validationType === "email"  ) {
			res = v.regx_validation({
				val : currentField.val ,
				err_1 : currentField.err_1,
				err_2 : currentField.err_2,
				expression: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
			});
		} else if ( validationType === "phone"  ) {
			res = v.regx_validation({
				val : currentField.val ,
				err_1 : currentField.err_1,
				err_2 : currentField.err_2 ,
				expression: /^[0-9]{9,11}$/
			});
		}else if ( validationType === "number" ){
			res = v.regx_validation({
				val : currentField.val ,
				err_1 : currentField.err_1,
				err_2 : currentField.err_2 ,
				expression: /^[0-9]+$/
			});
		}else if ( validationType === "licence" ){
			res = v.regx_validation({
				val : currentField.val ,
				err_1 : currentField.err_1,
				err_2 : currentField.err_2 ,
				expression: /^[0-9]+(-?[0-9]+)+$/
			});
		}
		if ( res !== true ) {
			errors.push("err")
			currentField.cssClass =  currentField.cssClass+" err-border ";
		}else {
			currentField.cssClass = currentField.cssClass + "succses-border";
		} 
	}

	// check to  see if error acourd
	if ( errors.length === 0 ) {
		return true;
	}else {
		return false;
	}

}



export const getUrl = () => { 
	
	const host 	= window.location.host;
	const protocol = window.location.protocol;
	// const url = protocol + "//" + host   + '/';
	const url = protocol + "//" + host;
	// .TwoCitiesOneBreak
	// const url = protocol + "//" + host   ;
	return url;
}


export const getImgUrl = () => { 
	
	const url = 'https://ru.goisrael.com/assets/img/';
	return url;
}



export const limitText = (string , length = 40 ) => {


	let trimmedString = string.substring(0, length);
	let dots = "";
	if ( string.length > length ) {
		dots =  "";
	}
	
	return trimmedString + "" + dots;

}


export const compareDates = (date1, date2) => {
    var patt = new RegExp(/[0-9]{1,2}-[0-9]{2}./);
    var res = patt.test(date2);
    var enDateFormat = [];
    if (res === true) {
		var dateToArr = date2.split('.');
		// console.log(dateToArr);
		var days = dateToArr[0];
		var daysToArr = days.split("-");
		var lastDay = daysToArr[1];
		dateToArr.shift(); // remove first arr cell
		dateToArr.unshift(lastDay); // add first arr cell
		enDateFormat[0] = dateToArr[1];
		enDateFormat[1] = dateToArr[0];
		enDateFormat[2] = dateToArr[2];
		var newDate = enDateFormat.join('.');
		var date2 = new Date(newDate);
		// console.log(' newDate ', newDate);
		
    } else {
		var dateToArr = date2.split('.');
		enDateFormat[0] = dateToArr[1];
		enDateFormat[1] = dateToArr[0];
		enDateFormat[2] = dateToArr[2];
		var newDate = enDateFormat.join('.');
		// console.log(' newDate ', newDate);
		var date2 = new Date(newDate);
    }
 
    var d1 = date1.getTime();
    var d1FullDate = date1.getDate() + "." + (date1.getMonth()+1)  + "."  + date1.getFullYear();  
    var d2 = date2.getTime();
    var d2FullDate = date2.getDate() + "." + (date2.getMonth()+1)  + "."  + date2.getFullYear();  


    var isTodayBigger = ( d1 > d2 ) ;
    if (d1FullDate === d2FullDate) {
      isTodayBigger = false;
    }
    return isTodayBigger;
  }



export const shuffle =  ( o = [] ) =>{ 
	
    for (var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
	

}

// Prod
export const geinstagramData=  async callback => {
	const res 	= await  Http.get("https://ru.goisrael.com/assets/insta-images.php");
	return res.data;
}


export const asyncgetWeather = async  () => {
	const weatherData    = await Http.get("https://goisrael.com/weather.php" , {params : {method: "get_weather"}});
	// console.log('WEATHER:', typeof weatherData); // object
	console.log('WEATHER:',  typeof weatherData.data); // 
	// return weatherData.data;
	return weatherData.data;
 } 

// Local 
// export const geinstagramData=  async callback => {
// 	const res 	= await  Http.get("https://view.activated.co.il/twocities/de/assets/insta-images.php");
// 	console.log('res' , res);
// 	return res.data;
// }
// export const asyncgetWeather = async  () => {
// 	const weatherData 	= await Http.get("https://view.activated.co.il/twocities/de/weather.php" , {params : {method: "get_weather"}});
// 	return weatherData.data;
// } 




// to do make  this async await 
export const getWeather = callback => {
	Http.get("https://ru.goisrael.com/weather.php" , {
       params : {
         method: "get_weather",
          city : "deadsea"        
       }
    })
	.then(res => {
	const deadSeaWeather = res.data.temperature;
	Http.get("https://ru.goisrael.com/weather.php" , {
       params : {
         method: "get_weather",
          city : "jerusalem"        
       }
    })
    .then(res => {
      	const jerusalemWeather = res.data.temperature;
      	const water_temp = res.data.water_temp;
       	Http.get("https://ru.goisrael.com/weather.php" , {
            params : {
             	method: "get_weather",
          		city : "Tel Aviv"    
           }
        })
        .then(res => {
          	const telAvivWeather = res.data.temperature;
	        const o = {
	        	jerusalemWeather : jerusalemWeather,
	        	water_temp :water_temp ,
	        	telAvivWeather : telAvivWeather,
	        	deadSeaWeather : deadSeaWeather,
	        }
	        callback(o)
	       
        });
       
       });
        
    });
}

// export const geinstagramData= callback => {
// 	Http.get("https://en.citiesbreak.com/assets/insta-images.php")
//     .then(res => {
//     	callback(res);
//     	// return res;        
//     });
// }



export const foundInString = ( text, match ) => {
	return new RegExp(match).test(text);
}


export const getBrowser = () => {
	let browser = detect();
 	
	// handle the case where we don't detect the browser
	if (!browser) {
		browser.name = 'centDetectBrowser';
		browser.version = '0';
	}

	return browser;
}



export const isMobile = () => {
	let isMobile = false;
	const windowW = window.innerWidth ;

	if ( windowW < 1000 ) {
		isMobile = true;
	}
	return isMobile
}


// WEBPACK FOOTER //
// ./src/Utility/Utility.js